module.exports = __webpack_public_path__ + "static/media/legend.039f3890.psd";